export const NORA_HOME_WALKTHROUGH_OVERLAY_COLOR = '#0A0A0C'
export const NORA_HOME_WALKTHROUGH_OVERLAY_OPACITY = 0.8
export const NORA_HOME_WALKTHROUGH_COPILOT_BACKDROP_COLOR = 'rgba(10, 10, 12, 0.8)'
